import { Box } from "@mui/material";
import type { JSX } from "react";

import { ImmoScout24Logo, SprengnetterLogo } from "@/assets";

export const ValuationReportHeader = (): JSX.Element => {
  return (
    <Box
      component="header"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
        padding: "13px 21px",
        gap: "21px",
        height: "65px",
        width: "100%",
        position: "fixed",
        top: 0,
        left: 0,
        backgroundColor: "white",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        borderBottom: "1px solid",
        borderColor: (theme) => theme.palette.divider,
      }}
    >
      <ImmoScout24Logo sx={{ width: "112px", height: "30px", color: "black" }} />
      <Box component="img" src="/data_transfer.png" alt="Data Transfer" />
      <SprengnetterLogo sx={{ width: "137px", height: "33px", ml: "-14px" }} />
    </Box>
  );
};
